var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0186 6.41016C8.70862 6.41016 6.01862 9.10016 6.01862 12.4102V15.3002C6.01862 15.9102 5.75862 16.8402 5.44862 17.3602L4.29862 19.2702C3.58862 20.4502 4.07862 21.7602 5.37862 22.2002C9.68862 23.6402 14.3386 23.6402 18.6486 22.2002C19.8586 21.8002 20.3886 20.3702 19.7286 19.2702L18.5786 17.3602C18.2786 16.8402 18.0186 15.9102 18.0186 15.3002V12.4102C18.0186 9.11016 15.3186 6.41016 12.0186 6.41016Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 6.70043C13.5599 6.61043 13.2399 6.54043 12.9099 6.50043C11.9499 6.38043 11.0299 6.45043 10.1699 6.70043C10.4599 5.96043 11.1799 5.44043 12.0199 5.44043C12.8599 5.44043 13.5799 5.96043 13.8699 6.70043Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 22.5596C15.0195 24.2096 13.6695 25.5596 12.0195 25.5596C11.1995 25.5596 10.4395 25.2196 9.89953 24.6796C9.35953 24.1396 9.01953 23.3796 9.01953 22.5596",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 3.5,
    r: 3,
    fill: "#F95C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotification);
export default __webpack_public_path__ + "static/media/new_notification.75c071ec255163542bebb27bb11c6964.svg";
export { ForwardRef as ReactComponent };